var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMonWeather = function SvgMonWeather(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 145 145",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 15.82,
    y1: 45.68,
    x2: 82.82,
    y2: -4.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 12.22,
    y1: 40.85,
    x2: 79.22,
    y2: -9.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 36.78,
    y1: 73.76,
    x2: 103.78,
    y2: 23.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 43.96,
    y1: 83.39,
    x2: 110.96,
    y2: 33.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 58.91,
    y1: 103.42,
    x2: 125.91,
    y2: 53.42,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M52.32,26.96c2.35,0,4.25-1.9,4.25-4.25v-8.55c0-2.35-1.9-4.25-4.25-4.25s-4.25,1.9-4.25,4.25v8.55c0,2.35,1.9,4.25,4.25,4.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.12,45.57l7.41,4.28c2.03,1.17,4.63.48,5.8-1.55,1.17-2.03.48-4.63-1.55-5.8l-7.41-4.28c-2.03-1.17-4.63-.48-5.8,1.55-1.17,2.03-.48,4.63,1.55,5.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.53,89.46l-7.41,4.28c-2.03,1.17-2.73,3.77-1.55,5.8,1.18,2.04,3.78,2.72,5.8,1.55l7.41-4.28c2.03-1.17,2.73-3.77,1.55-5.8-1.17-2.03-3.77-2.73-5.8-1.55Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.11,49.86l7.41-4.28c2.03-1.17,2.73-3.77,1.55-5.8-1.17-2.03-3.77-2.73-5.8-1.55l-7.41,4.28c-2.03,1.17-2.73,3.77-1.55,5.8,1.18,2.04,3.78,2.72,5.8,1.55Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M112.97,75.68c-4.86-12.01-16.66-19.95-29.64-19.9-5.32-11.84-17.22-20.11-31.02-20.11-18.74,0-33.98,15.25-33.98,33.98,0,12.02,6.28,22.6,15.72,28.65-10.07,15.91,1.38,36.77,20.22,36.77,66.84-.07,63.18.17,64.35-.19,14.85-1.67,26.37-14.27,26.37-29.55,0-17.45-14.91-30.99-32.02-29.65ZM26.83,69.66c0-14.05,11.43-25.49,25.49-25.49,9.48,0,17.76,5.2,22.15,12.9-13.42,3.93-22.74,16.19-22.89,30.25-4.22.46-8.2,2.04-11.63,4.62-7.82-4.36-13.12-12.71-13.12-22.28ZM117.02,126.52h0c-1.51.11-40.06.04-62.74.06-14.01,0-20.83-17.36-10.41-26.88,3.13-2.86,7.29-4.38,11.83-3.96,2.74.25,4.97-2.12,4.59-4.82-1.97-14.06,8.91-26.64,23.13-26.64,10.52,0,19.79,7.08,22.55,17.22.59,2.17,2.76,3.5,4.96,3.05,13.24-2.74,25.57,7.38,25.57,20.8,0,10.98-8.56,20.27-19.48,21.17Z"
  })));
};
export default SvgMonWeather;